import { Alert } from 'antd';

export function PageBreakConfigComponent() {
  return (
    <Alert
      style={{ marginBottom: 16 }}
      message="Elemento Documento PDF"
      description="Questo elemento non è visibile in fase di compilazione, ma sarà applicato
  nel pdf generato."
    />
  );
}
